/* lua.js generated code 0.3.0 */

require("clover/data/UserManager")
var Event = require("cocos/framework/components/event")
UserCoin = xClass("UserCoin", Event)
UserCoinEvent = table(
    [1, "Increase", "USERCOINEVENT.INCREASE"],
    [1, "Decrease", "USERCOINEVENT.DECREASE"],
    [1, "Update", "USERCOINEVENT.UPDATE"]
)
var instance = null
UserCoin.getInstance = function () {
    var self = this
    if (!instance) {
        instance = UserCoin.new()
    }
    return instance
}
UserCoin.prototype.ctor = function () {
    var self = this
    self.bind(self)
    self.lockedCoin = 0
}
UserCoin.prototype.addCoin = function (num) {
    var self = this
    var user = UserManager.getInstance().getUserRef()
    user.setCoin(user.getCoin() + num)
    self.dispatchEvent(table([1, "name", UserCoinEvent.Increase], [1, "num", num]))
    self.dispatchEvent(table([1, "name", UserCoinEvent.Update]))
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}
UserCoin.prototype.consumeCoin = function (num) {
    var self = this
    var user = UserManager.getInstance().getUserRef()
    user.setCoin(Math.max(user.getCoin() - num, 0))
    self.dispatchEvent(table([1, "name", UserCoinEvent.Decrease], [1, "num", num]))
    self.dispatchEvent(table([1, "name", UserCoinEvent.Update]))
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}
UserCoin.prototype.lockCoin = function (num) {
    var self = this
    self.lockedCoin = Math.min(self.lockedCoin + num, self.getCoin())
}
UserCoin.prototype.unlockCoin = function (num) {
    var self = this
    self.lockedCoin = Math.max(self.lockedCoin - num, 0)
}
UserCoin.prototype.getCoin = function () {
    var self = this
    // WARN: maybe multi result
    return UserManager.getInstance().getUserRef().getCoin()
}
UserCoin.prototype.checkCoin = function (num) {
    var self = this
    return self.getAvaliableCoin() >= num
}
UserCoin.prototype.getAvaliableCoin = function () {
    var self = this
    // WARN: maybe multi result
    return Math.max(self.getCoin() - self.lockedCoin, 0)
}
function convert(num) {
    num = tonumber(num) || 0
    if (num >= 100000) {
        return Math.floor(num / 10000) + getText("clover.text.1")   // xx万
    }
    return num
}
//显示用
UserCoin.prototype.getAvaliableCashString = function () {
    var self = this
    // WARN: maybe multi result
    return convert(self.getAvaliableCoin())
}

